module.exports = __webpack_public_path__ + "img/banner-left.9872747b.png";